import React from 'react'
import decodeHtml from '../functions/decodeHtml'
import Translation from '../General/Translation'

const Directors = ({directors ,translation}) => {
    return (
        <div className={'actors'}>
            {directors.length > 0 && <h2 className={'title-large'}><Translation id="directors" trans={translation}>Regisseur:in</Translation></h2>}
            <div className={'actors-wrapper'}>
            {directors.map((director, index) => {
        
                const defaultImage = director.imageURL === '' || !director.imageURL ? ' default-image' : ''
                
                const backgroundUrl = director.imageURL === '' || !director.imageURL ? '' : director.imageURL
                
                const styles = {
                    backgroundImage: `url(${backgroundUrl})`
                }
            
                return director.imageURL === '' || !director.imageURL ? (
                    <div key={index} className={'actor-wrapper'}>
                        <div className={'actor-image-wrapper'}>
                            <div className={'actor-image theme-radius-posters-top' + defaultImage }/>
                        </div>
                        <div className={'actor-names theme-radius-posters-bottom'}>
                            <p className={'text-medium'}>{decodeHtml(director.name)}</p>
                        </div>
                    </div>
                ) : (
                    <div key={index} className={'actor-wrapper'}>
                        <div className={'actor-image-wrapper'}>
                            <div className={'actor-image theme-radius-posters-top'}  style={styles}/>
                        </div>
                        <div className={'actor-names theme-radius-posters-bottomtheme-radius-posters-bottom'}>
                            <p className={'text-medium'}>{decodeHtml(director.name)}</p>
                        </div>
                    </div>
                )
                })}
            </div>
        </div>
    )  
}


export default Directors

